// extracted by mini-css-extract-plugin
module.exports = {"styles":"effects_styles__uuTsg"};